module.exports = __webpack_public_path__ + "img/sweden.eed57d73.svg";